import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'

import { ProductBuyBoxCom } from './ProductBuyBoxCom'
import { ProductBuyBoxRebrushed } from './ProductBuyBoxRebrushed'
import { ProductBuyBoxRxCh } from './ProductBuyBoxRxCh'

export const ProductBuyBox: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { product } = useProductPageContext()

  const isRxProduct = productAccessorIsPrescriptionProduct(product)

  if (tenant === TENANT.COM) {
    return <ProductBuyBoxCom />
  }

  if (tenant === TENANT.CH && isRxProduct) {
    return <ProductBuyBoxRxCh />
  }

  return <ProductBuyBoxRebrushed />
}
